import { createStyledContext } from "../helpers/createStyledContext";
const listeners = /* @__PURE__ */ new Set(), ComponentContext = createStyledContext({
  inText: !1,
  language: null,
  animationDriver: null,
  groups: {
    emit: (name, state) => {
      listeners.forEach((l) => l(name, state));
    },
    subscribe(cb) {
      return listeners.add(cb), () => {
        listeners.delete(cb);
      };
    },
    state: {}
  }
});
export {
  ComponentContext
};
//# sourceMappingURL=ComponentContext.js.map
